<template>
    <el-form :model="devcCustField" :rules="roles" ref="devcCustField" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">字段编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="devcCustField.name" :disabled="id != null" class="width-1-5x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">中文标题</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="title">
                        <el-input v-model="devcCustField.title" class="width-1-5x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>类型</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="type">
                        <!--<el-select v-model="devcCustField.type" placeholder="请选择">-->
                        <!--<el-option v-for="item in typeList" :label="item.label" :value="item.value"></el-option>-->
                        <!--</el-select>-->
                        <span>字符串</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否视频</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="fileFlag">
                        <el-radio-group v-model="devcCustField.fileFlag">
                            <el-radio :label="false">否</el-radio>
                            <el-radio :label="true">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>说明</label>
                </div>
                <div class="form-value">
                    <el-form-item>
                        <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入说明" v-model="devcCustField.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    //
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getSimpleJavaTypes, getSimpleJavaTypesMap} from './selectDlg'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-devc-cust-field-save',
        props: ['id'],
        data: function () {
            let validateNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            }
            //
            return {
                devcCustField: {
                    name: null,
                    title: null,
                    type: 'String',
                    fileFlag: false,
                    desc: null
                },
                roles: {
                    name: [{
                        validator: validateNull,
                        trigger: 'blur'
                    }],
                    title: [{
                        validator: validateNull,
                        trigger: 'blur'
                    }],
                    type: [{
                        validator: validateNull,
                        trigger: 'change'
                    }]
                },
                typeList: []
            }
        },
        created: function () {
            let typeList = [];
            let types = getSimpleJavaTypes(true);
            let typeMap = getSimpleJavaTypesMap();
            types.forEach(function (type) {
                typeList.push({
                    value: type,
                    label: typeMap[type]
                });
            });
            this.typeList = typeList;
            if (!Utils.isNoB(this.id)) {
                this.getDevcCustField();
            }
        },
        methods: {
            getDevcCustField: function () {
                let self = this;
                let loading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldById({
                    id: this.id
                }, function (result) {
                    loading.hide();
                    if (result.type == "info") {
                        self.devcCustField = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['devcCustField'].validate(function (valid) {
                    if (valid) {
                        result.type = "info";
                        result.data = self.devcCustField;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/devcCust/DevcCustFieldSave.vue